const Content = ({ title, children }) => {
	return (
		<>
			<h2 className='large-title center-title tagh2 mt-3'>{title}</h2>
			{children}
		</>
	);
};

export default Content;
